define((require) => {
    "use strict";

    var SpinnerView = require("shared/ui/common/SpinnerView");

    /**
     * A more dimmed version of the default spinner, by courtesy of uncle Leifelt.
     *
     * @class SlimSpinnerView
     */
    return SpinnerView.extend("SlimSpinnerView", {

        options: {
            width: 2,
            opacity: 0,
            radius: 8,
            trail: 62
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/SlimSpinnerView.js